// // import React, { useState, useEffect } from 'react'
// // import { DataGrid } from '@mui/x-data-grid'
// // import { Box } from '@mui/material'
// // import apiClient from '../../../clients/ApiClient'
// // import io from 'socket.io-client'
// // import AttendanceUpdate from './AttendanceUpdate'

// // const socket = io('https://api.asconlineportal.com', {
// //     path: '/socket.io/',
// //     transports: ['websocket']
// // })

// // const AttendanceTodayList = () => {
// //     const [employees, setEmployees] = useState([])
// //     const [loading, setLoading] = useState(true)
// //     // Assuming the localStorage item is formatted like "employee_94-080124"
// //     const sessionUserId = localStorage.getItem('employeeId')?.split('_')[1]

// //     // Fetch DTR data from the API
// //     const fetchDtrData = async () => {
// //         try {
// //             const today = new Date()
// //             const dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString()
// //             const dateEnd = new Date(
// //                 today.getFullYear(),
// //                 today.getMonth(),
// //                 today.getDate(),
// //                 23,
// //                 59,
// //                 59,
// //                 999
// //             ).toISOString()

// //             const attendance = {
// //                 dateStart,
// //                 dateEnd
// //             }

// //             const response = await apiClient.get('/dtr/', {
// //                 params: attendance
// //             })

// //             const formattedData = response.data
// //                 .map((employee, index) => {
// //                     const record = employee.dailyTimeRecord && employee.dailyTimeRecord[0]
// //                     if (!record) {
// //                         return null
// //                     }

// //                     return {
// //                         id: record.id,
// //                         employeeId: employee.employeeId, // Include employeeId for session check
// //                         name: employee.fullName,
// //                         // Store the raw times so you can later use them for condition checking
// //                         timeIn: record.timeIn,
// //                         timeOut: record.timeOut,
// //                         remarks: record.remarks ? record.remarks : '-'
// //                     }
// //                 })
// //                 .filter(Boolean)

// //             setEmployees(formattedData)
// //             setLoading(false)
// //         } catch (error) {
// //             console.error('Error fetching DTR data:', error)
// //             setLoading(false)
// //         }
// //     }

// //     useEffect(() => {
// //         fetchDtrData()

// //         socket.on('attendanceUpdated', (updatedAttendance) => {
// //             console.log('Attendance Updated:', updatedAttendance)
// //             fetchDtrData()
// //         })

// //         return () => {
// //             socket.off('attendanceUpdated')
// //         }
// //     }, [])

// //     const columns = [
// //         { field: 'name', headerName: 'Name', width: 300 },
// //         {
// //             field: 'timeIn',
// //             headerName: 'Time In',
// //             width: 150,
// //             renderCell: (params) => (params.value ? new Date(params.value).toLocaleTimeString() : '-')
// //         },
// //         {
// //             field: 'timeOut',
// //             headerName: 'Time Out',
// //             width: 150,
// //             renderCell: (params) => (params.value ? new Date(params.value).toLocaleTimeString() : '-')
// //         },
// //         {
// //             field: 'remarks',
// //             headerName: 'Working At',
// //             width: 150,
// //             renderCell: (params) => {
// //                 const remark = params.value
// //                 let bgColor = ''
// //                 switch (remark) {
// //                     case 'Home':
// //                         bgColor = 'bg-red-100 text-red-700'
// //                         break
// //                     case 'Office':
// //                         bgColor = 'bg-green-100 text-green-700'
// //                         break
// //                     case 'Offsite':
// //                         bgColor = 'bg-blue-100 text-blue-700'
// //                         break
// //                     default:
// //                         bgColor = 'bg-gray-100 text-gray-700'
// //                 }

// //                 return <span className={`px-3 py-1 rounded-full font-semibold text-sm ${bgColor}`}>{remark}</span>
// //             }
// //         }
// //     ]

// //     const [selectedEmployee, setSelectedEmployee] = useState(null)
// //     const [modalOpen, setModalOpen] = useState(false)

// //     const handleRowClick = (params) => {
// //         const row = params.row
// //         const isCurrentUser = row.employeeId === sessionUserId
// //         const hasTimeIn = !!row.timeIn
// //         const hasNotTimedOut = !row.timeOut

// //         if (isCurrentUser && hasTimeIn) {
// //             setSelectedEmployee(row)
// //             setModalOpen(true)
// //         } else {
// //             console.log('Not allowed to update: Either not your own record, no time in, or already timed out.')
// //         }
// //     }

// //     return (
// //         <Box sx={{ height: '75%', width: 750 }}>
// //             <DataGrid
// //                 className="bg-white"
// //                 rows={employees}
// //                 columns={columns.map((column) => ({
// //                     ...column,
// //                     headerClassName: 'header-bold'
// //                 }))}
// //                 pageSize={10}
// //                 rowsPerPageOptions={[10]}
// //                 loading={loading}
// //                 disableSelectionOnClick={false} // Enable row selection
// //                 onRowClick={handleRowClick} // Handle row click event
// //                 sx={{
// //                     '& .MuiDataGrid-columnHeaders': {
// //                         fontWeight: 'bold'
// //                     },
// //                     '& .MuiDataGrid-cell': {
// //                         cursor: 'pointer',
// //                         pointerEvents: 'auto'
// //                     }
// //                 }}
// //             />

// //             {/* Modal to update working at */}
// //             {selectedEmployee && (
// //                 <AttendanceUpdate open={modalOpen} onClose={() => setModalOpen(false)} employee={selectedEmployee} />
// //             )}
// //         </Box>
// //     )
// // }

// // export default AttendanceTodayList

// import React, { useState, useEffect } from 'react'
// import { DataGrid } from '@mui/x-data-grid'
// import { Box } from '@mui/material'
// import apiClient from '../../../clients/ApiClient'
// import io from 'socket.io-client'
// import AttendanceUpdate from './AttendanceUpdate'

// const socket = io('https://api.asconlineportal.com', {
//     path: '/socket.io/',
//     transports: ['websocket']
// })

// const AttendanceTodayList = () => {
//     const [employees, setEmployees] = useState([])
//     const [loading, setLoading] = useState(true)
//     const sessionUserId = localStorage.getItem('employeeId')?.split('_')[1]

//     const fetchDtrData = async () => {
//         try {
//             const today = new Date()
//             const dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString()
//             const dateEnd = new Date(
//                 today.getFullYear(),
//                 today.getMonth(),
//                 today.getDate(),
//                 23,
//                 59,
//                 59,
//                 999
//             ).toISOString()

//             const attendance = { dateStart, dateEnd }

//             const response = await apiClient.get('/dtr/', { params: attendance })

//             const formattedData = response.data
//                 .map((employee, index) => {
//                     const record = employee.dailyTimeRecord?.[0]
//                     if (!record) return null
//                     return {
//                         id: record.id,
//                         employeeId: employee.employeeId,
//                         name: employee.fullName,
//                         timeIn: record.timeIn,
//                         timeOut: record.timeOut,
//                         remarks: record.remarks || '-'
//                     }
//                 })
//                 .filter(Boolean)

//             setEmployees(formattedData)
//             setLoading(false)
//         } catch (error) {
//             console.error('Error fetching DTR data:', error)
//             setLoading(false)
//         }
//     }

//     useEffect(() => {
//         fetchDtrData()
//         socket.on('attendanceUpdated', () => fetchDtrData())
//         return () => socket.off('attendanceUpdated')
//     }, [])

//     const columns = [
//         {
//             field: 'name',
//             headerName: 'Employee Name',
//             width: 300,
//             headerAlign: 'left',
//             cellClassName: 'text-base text-gray-800 font-medium'
//         },
//         {
//             field: 'timeIn',
//             headerName: 'Time In',
//             width: 150,
//             renderCell: (params) =>
//                 params.value ? (
//                     <span className="text-green-700 font-semibold">{new Date(params.value).toLocaleTimeString()}</span>
//                 ) : (
//                     <span className="text-gray-400 italic">-</span>
//                 )
//         },
//         {
//             field: 'timeOut',
//             headerName: 'Time Out',
//             width: 150,
//             renderCell: (params) =>
//                 params.value ? (
//                     <span className="text-red-700 font-semibold">{new Date(params.value).toLocaleTimeString()}</span>
//                 ) : (
//                     <span className="text-gray-400 italic">-</span>
//                 )
//         },
//         {
//             field: 'remarks',
//             headerName: 'Working At',
//             width: 160,
//             renderCell: (params) => {
//                 const remark = params.value
//                 let bgColor = ''
//                 switch (remark) {
//                     case 'Home':
//                         bgColor = 'bg-red-100 text-red-600'
//                         break
//                     case 'Office':
//                         bgColor = 'bg-green-100 text-green-700'
//                         break
//                     case 'Offsite':
//                         bgColor = 'bg-blue-100 text-blue-700'
//                         break
//                     default:
//                         bgColor = 'bg-gray-100 text-gray-600'
//                 }

//                 return (
//                     <span className={`px-3 py-1 rounded-full text-sm font-semibold tracking-wide shadow-sm ${bgColor}`}>
//                         {remark}
//                     </span>
//                 )
//             }
//         }
//     ]

//     const [selectedEmployee, setSelectedEmployee] = useState(null)
//     const [modalOpen, setModalOpen] = useState(false)

//     const handleRowClick = (params) => {
//         const row = params.row
//         const isCurrentUser = row.employeeId === sessionUserId
//         const hasTimeIn = !!row.timeIn
//         const hasNotTimedOut = !row.timeOut

//         if (isCurrentUser && hasTimeIn && hasNotTimedOut) {
//             setSelectedEmployee(row)
//             setModalOpen(true)
//         }
//     }

//     return (
//         <Box
//             sx={{
//                 height: '75%',
//                 width: 750,
//                 backgroundColor: '#f9fafb',
//                 borderRadius: 2,
//                 p: 2,
//                 boxShadow: 2
//             }}
//         >
//             <DataGrid
//                 rows={employees}
//                 columns={columns.map((column) => ({
//                     ...column,
//                     headerClassName: 'header-bold'
//                 }))}
//                 pageSize={10}
//                 rowsPerPageOptions={[10]}
//                 loading={loading}
//                 onRowClick={handleRowClick}
//                 sx={{
//                     '& .MuiDataGrid-columnHeaders': {
//                         fontSize: '1rem',
//                         fontWeight: 'bold',
//                         color: '#1f2937',
//                         backgroundColor: '#e5e7eb'
//                     },
//                     '& .MuiDataGrid-cell': {
//                         fontSize: '0.95rem',
//                         color: '#374151',
//                         py: 1
//                     },
//                     '& .MuiDataGrid-row:hover': {
//                         backgroundColor: '#f3f4f6',
//                         cursor: 'pointer'
//                     },
//                     '& .MuiDataGrid-selectedRowCount': {
//                         display: 'none'
//                     }
//                 }}
//                 disableSelectionOnClick
//             />

//             {selectedEmployee && (
//                 <AttendanceUpdate open={modalOpen} onClose={() => setModalOpen(false)} employee={selectedEmployee} />
//             )}
//         </Box>
//     )
// }

// export default AttendanceTodayList

import React, { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box } from '@mui/material'
import apiClient from '../../../clients/ApiClient'
import io from 'socket.io-client'
import AttendanceUpdate from './AttendanceUpdate'

const socket = io('https://api.asconlineportal.com', {
    path: '/socket.io/',
    transports: ['websocket']
})

const AttendanceTodayList = () => {
    const [employees, setEmployees] = useState([])
    const [loading, setLoading] = useState(true)
    const sessionUserId = localStorage.getItem('employeeId')?.split('_')[1]

    const fetchDtrData = async () => {
        try {
            const today = new Date()
            const dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString()
            const dateEnd = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                23,
                59,
                59,
                999
            ).toISOString()

            const attendance = { dateStart, dateEnd }

            const response = await apiClient.get('/dtr/', { params: attendance })

            const formattedData = response.data
                .map((employee, index) => {
                    const record = employee.dailyTimeRecord?.[0]
                    if (!record) return null
                    return {
                        id: record.id,
                        employeeId: employee.employeeId,
                        name: employee.fullName,
                        timeIn: record.timeIn,
                        timeOut: record.timeOut,
                        remarks: record.remarks || '-'
                    }
                })
                .filter(Boolean)

            setEmployees(formattedData)
            setLoading(false)
        } catch (error) {
            console.error('Error fetching DTR data:', error)
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchDtrData()
        socket.on('attendanceUpdated', () => fetchDtrData())
        return () => socket.off('attendanceUpdated')
    }, [])

    const columns = [
        {
            field: 'name',
            headerName: 'Employee Name',
            width: 300,
            headerAlign: 'left',
            cellClassName: 'text-base text-gray-800 font-medium'
        },
        {
            field: 'timeIn',
            headerName: 'Time In',
            width: 150,
            renderCell: (params) =>
                params.value ? (
                    <span className="text-green-700 font-semibold">{new Date(params.value).toLocaleTimeString()}</span>
                ) : (
                    <span className="text-gray-400 italic">-</span>
                )
        },
        {
            field: 'timeOut',
            headerName: 'Time Out',
            width: 150,
            renderCell: (params) =>
                params.value ? (
                    <span className="text-red-700 font-semibold">{new Date(params.value).toLocaleTimeString()}</span>
                ) : (
                    <span className="text-gray-400 italic">-</span>
                )
        },
        {
            field: 'remarks',
            headerName: 'Working At',
            width: 160,
            renderCell: (params) => {
                const remark = params.value
                let badgeClass = 'badge-neutral'
                switch (remark) {
                    case 'Home':
                        badgeClass = 'badge-danger'
                        break
                    case 'Office':
                        badgeClass = 'badge-success'
                        break
                    case 'Offsite':
                        badgeClass = 'badge-info'
                        break
                }

                return <span className={badgeClass}>{remark}</span>
            }
        }
    ]

    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)

    const handleRowClick = (params) => {
        const row = params.row
        const isCurrentUser = row.employeeId === sessionUserId
        const hasTimeIn = !!row.timeIn
        const hasNotTimedOut = !row.timeOut

        if (isCurrentUser && hasTimeIn && hasNotTimedOut) {
            setSelectedEmployee(row)
            setModalOpen(true)
        }
    }

    return (
        <Box
            sx={{
                height: '75%',
                width: '100%',
                backgroundColor: '#f9fafb',
                borderRadius: 2,
                p: 2,
                boxShadow: 2
            }}
        >
            <DataGrid
                rows={employees}
                columns={columns.map((column) => ({
                    ...column,
                    headerClassName: 'header-bold'
                }))}
                pageSize={10}
                rowsPerPageOptions={[10]}
                loading={loading}
                onRowClick={handleRowClick}
                sx={{
                    '& .MuiDataGrid-columnHeaders': {
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: '#1f2937',
                        backgroundColor: '#e5e7eb'
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: '0.95rem',
                        color: '#374151',
                        py: 1
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f3f4f6',
                        cursor: 'pointer'
                    },
                    '& .MuiDataGrid-selectedRowCount': {
                        display: 'none'
                    }
                }}
                disableSelectionOnClick
            />

            {selectedEmployee && (
                <AttendanceUpdate open={modalOpen} onClose={() => setModalOpen(false)} employee={selectedEmployee} />
            )}
        </Box>
    )
}

export default AttendanceTodayList
